import { useState, useEffect } from 'react';
import { useFirebase } from '../context/FirebaseContext';

export const useFirebaseData = (collectionName) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAllDocuments } = useFirebase();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getAllDocuments(collectionName);
        setData(result || []);
      } catch (err) {
        console.error(`Error fetching ${collectionName}:`, err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [collectionName, getAllDocuments]);

  return { data, loading, error };
}; 